<template>
    <div class="quarter-bank">
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item>二级部门：
                <el-cascader
                        v-model=formInline.dept
                        :options="deptsList"
                        :props="{ multiple: true, }"
                        :show-all-levels="false"
                        collapse-tags
                        clearable>
                </el-cascader>
            </el-form-item>
            <el-form-item>职级：
                <el-select v-model="formInline.level" multiple  placeholder="请选择">
                    <el-option
                            v-for="item in levelList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getWeekTaskList">查询</el-button>
            </el-form-item>

        </el-form>
        <el-scrollbar style="width: 100%">
        <table class="drag-container" style="font-size: 12px;width: 100%" >
            <thead>
            <tr style="font-size: 12px;">
                <th width="50" style="min-width: 50px">序号</th>
                <th style="width:150px;min-width: 150px">期次</th>
                <template v-if="weekTaskList.length>0">
                    <th style="width:200px;min-width: 200px" v-for="item in weekTaskList[this.titleLenght-1].lst">{{item.userName}}</th>
                </template>
            </tr>
            </thead>
            <tr v-for="(item,index) in weekTaskList">
                <td>{{index+1}}</td>
                <td>{{item.week}}</td>
                <td v-for="item1 in item.lst" style="padding:1px 5px;text-align: left;vertical-align:top!important"><pre>{{item1.answer}}</pre></td>
            </tr>
        </table>
        </el-scrollbar>
    </div>
</template>

<script>
//导入 HTTP请求方法

    //定义组件
    export default {
        data() {
            return {
                formInline: {
                    currentPage: 1,
                    pageSize: 50,
                    classId:15,
                    dept:null,
                    level:null


                },
                weekTaskList:[],
                deptsList:[],
                levelList:[{"value":"L0.5","name":"L0.5"},{"value":"L1","name":"L1"},{"value":"L1.5","name":"L1.5"},{"value":"L2","name":"L2"},
                    {"value":"L2.5","name":"L2.5"},{"value":"L3","name":"L3"},
                    {"value":"L3.5","name":"L3.5"},{"value":"L4","name":"L4"}, {"value":"L5","name":"L5"}, {"value":"L6","name":"L6"}, {"value":"L7","name":"L7"},
                    {"value":"E1","name":"E1"},{"value":"E2","name":"E2"},{"value":"E2.5","name":"E2.5"},{"value":"E3","name":"E3"},{"value":"E3.5","name":"E3.5"},
                    {"value":"E4","name":"E4"},{"value":"E4.5","name":"E4.5"},{"value":"E5","name":"E5"},{"value":"E6","name":"E6"},{"value":"E7","name":"E7"},{"value":"E8","name":"E8"},
                ],
                titleLenght:0,
            }
        },
        computed:{

        },
        props:['sectionClassId'],
        //挂载时候执行
        mounted() {
            this.getDepartsCascader();
            this.getWeekTaskList()
        },
        methods: {
            getWeekTaskList() {
                console.log(this.formInline.dept)
                console.log(this.formInline.level)
                this.$store.dispatch('getWeekTaskList',{"deptIds":JSON.stringify(this.formInline.dept),"levels":JSON.stringify(this.formInline.level)}).then(res=>{
                    this.weekTaskList = res.data;
                    this.titleLenght=res.title;
                })
            },
            getDepartsCascader(){
                this.$store.dispatch('getDepartsCascader',{}).then(res=>{
                    console.log(res)
                    this.deptsList = res;
                })
            }
         },


    }
</script>



// WEBPACK FOOTER //
// src/components/cooperative/weekTask.vue